// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import CloseSquareTwoToneSvg from "@ant-design/icons-svg/es/asn/CloseSquareTwoTone";
import AntdIcon from '../components/AntdIcon';

var CloseSquareTwoTone = function CloseSquareTwoTone(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: CloseSquareTwoToneSvg
  }));
};

CloseSquareTwoTone.displayName = 'CloseSquareTwoTone';
export default React.forwardRef(CloseSquareTwoTone);


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@ant-design_icons@4.0.6@@ant-design/icons/es/icons/CloseSquareTwoTone.js
// module id = 795
// module chunks = 0